module.exports = __webpack_public_path__ + "img/dual-heating-md.a735e41f.svg";